import { useRef } from 'react';
import { Control, useFormState, FieldValues } from 'react-hook-form';

const useErrors = <T extends FieldValues>({ control }: { control: Control<T> }) => {
  const { errors } = useFormState({ control });
  const hasErrors = Object.keys(errors).length > 0;
  const formRef = useRef<HTMLFormElement>(null);

  return {
    errors: { ...errors }, // копирование и правда нужно
    hasErrors,
    formRef,
  };
};

export default useErrors;
